import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AgentAuthContext = createContext(null);

export const AgentAuthProvider = ({ children }) => {
  const [agent, setAgent] = useState(null); // null=loading, false=guest, obj=logged in
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    const boot = async () => {
      try {
        const { data } = await api.get("/agent/auth/me");
        setAgent(data);
      } catch {
        setAgent(false);
      } finally {
        setInitializing(false);
      }
    };
    boot();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/agent/auth/login", { username, password });
    // 2FA gate — do not set agent; caller must complete with verify2FA
    if (data?.requires_2fa) {
      return { requires_2fa: true, challenge_token: data.challenge_token, username: data.username };
    }
    if (data?.token) localStorage.setItem("ss_agent_token", data.token);
    setAgent(data.agent);
    return data;
  };

  const verify2FA = async ({ challenge_token, totp_code, backup_code }) => {
    const { data } = await api.post("/agent/auth/2fa-verify", { challenge_token, totp_code, backup_code });
    if (data?.token) localStorage.setItem("ss_agent_token", data.token);
    setAgent(data.agent);
    return data;
  };

  const logout = async () => {
    try { await api.post("/agent/auth/logout"); } catch (_) { /* ignore */ }
    localStorage.removeItem("ss_agent_token");
    setAgent(false);
  };

  const refresh = async () => {
    try {
      const { data } = await api.get("/agent/auth/me");
      setAgent(data);
      return data;
    } catch { return null; }
  };

  return (
    <AgentAuthContext.Provider value={{ agent, login, verify2FA, logout, refresh, initializing }}>
      {children}
    </AgentAuthContext.Provider>
  );
};

export const useAgentAuth = () => useContext(AgentAuthContext);
